import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 custom-padding-30 border-bottom pb-4 custom-padding-30" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "position-relative table-src-form" }
const _hoisted_5 = { class: "default-table-area style-three recent-calls for-data-table" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = {
  class: "table align-middle border-0",
  id: "myTable"
}
const _hoisted_8 = { class: "border-bottom" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "up-down-arrow" }
const _hoisted_11 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_12 = {
  key: 1,
  class: "material-symbols-outlined"
}
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex-grow-1 ms-2" }
const _hoisted_17 = { class: "fs-14 fw-medium mb-0" }
const _hoisted_18 = { class: "fs-12 text-body" }
const _hoisted_19 = {
  key: 0,
  class: "text-primary fw-medium"
}
const _hoisted_20 = {
  key: 1,
  class: "text-danger-50 fw-medium"
}
const _hoisted_21 = { class: "fw-medium" }
const _hoisted_22 = {
  key: 0,
  class: "text-success-50 fw-medium"
}
const _hoisted_23 = {
  key: 1,
  class: "text-danger-50 fw-medium"
}
const _hoisted_24 = {
  key: 2,
  class: "text-primary-div-50 fw-medium"
}
const _hoisted_25 = { class: "fw-medium" }
const _hoisted_26 = { class: "fw-medium" }
const _hoisted_27 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 custom-padding-30 pt-4" }
const _hoisted_28 = { class: "fs-12 fw-medium" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "fs-12 fw-medium me-2" }
const _hoisted_31 = { "aria-label": "Page navigation example" }
const _hoisted_32 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Recent Calls", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control border-0",
            id: "SearchControl",
            style: {"width":"265px"},
            placeholder: "Search for a name....",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"dropdown action-opt\" data-v-21de2c96><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-21de2c96><i data-feather=\"more-vertical\" data-v-21de2c96></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-21de2c96><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"clock\" data-v-21de2c96></i> Today </a></li><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"pie-chart\" data-v-21de2c96></i> Last 7 Days </a></li><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"rotate-cw\" data-v-21de2c96></i> Last Month </a></li><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"calendar\" data-v-21de2c96></i> Last 1 Year </a></li><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"bar-chart\" data-v-21de2c96></i> All Time </a></li><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"eye\" data-v-21de2c96></i> View </a></li><li data-v-21de2c96><a class=\"dropdown-item\" href=\"javascript:;\" data-v-21de2c96><i data-feather=\"trash\" data-v-21de2c96></i> Delete </a></li></ul></div>", 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", _hoisted_8, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: header.key,
                  onClick: ($event: any) => (_ctx.sortTable(header.key)),
                  style: {"cursor":"pointer"},
                  class: "bg-transparent"
                }, [
                  _createTextVNode(_toDisplayString(header.label) + " ", 1),
                  _createElementVNode("span", _hoisted_10, [
                    (_ctx.sortedColumn === header.key && _ctx.sortOrder === 'asc')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_11, " arrow_upward "))
                      : _createCommentVNode("", true),
                    (_ctx.sortedColumn === header.key && _ctx.sortOrder === 'desc')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_12, " arrow_downward "))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_9))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (call) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: call.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: call.image,
                        class: "rounded-circle",
                        alt: "user"
                      }, null, 8, _hoisted_15)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h4", _hoisted_17, _toDisplayString(call.name), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(call.number), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  (call.type === 'Inbound')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Inbound "))
                    : _createCommentVNode("", true),
                  (call.type === 'Outbound')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Outbound "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(call.duration), 1)
                ]),
                _createElementVNode("td", null, [
                  (call.status === 'Resolved')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Resolved "))
                    : _createCommentVNode("", true),
                  (call.status === 'Pending')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Pending "))
                    : _createCommentVNode("", true),
                  (call.status === 'Dropped')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Dropped "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(call.time), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(call.csat), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, " Items per page: " + _toDisplayString(_ctx.rowsPerPage), 1),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.startItem) + " - " + _toDisplayString(_ctx.endItem) + " of " + _toDisplayString(_ctx.calls.length), 1),
            _createElementVNode("nav", _hoisted_31, [
              _createElementVNode("ul", _hoisted_32, [
                _createElementVNode("li", {
                  class: _normalizeClass(['page-item', { disabled: _ctx.currentPage === 1 }])
                }, [
                  _createElementVNode("button", {
                    class: "page-link icon",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                    disabled: _ctx.currentPage === 1
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "material-symbols-outlined" }, " keyboard_arrow_left ", -1)
                  ]))], 8, _hoisted_33)
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass([
                    'page-item',
                    { disabled: _ctx.currentPage === _ctx.totalPages },
                  ])
                }, [
                  _createElementVNode("button", {
                    class: "page-link icon",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                    disabled: _ctx.currentPage === _ctx.totalPages
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "material-symbols-outlined" }, " keyboard_arrow_right ", -1)
                  ]))], 8, _hoisted_34)
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}